import { ASSET_NBVS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/asset_nbvs_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['assetNbvsIndex']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
